<template>
  <div class="order-list tt-custom-tab table-container">
    <div class="search-bar">
      <div>
        <el-select style="width:100%;" v-model="searchForm.business_id" clearable filterable
                   :popper-append-to-body="false"
                   class="input-width" placeholder="商家" @change="confirmMerchant">
          <el-option v-for="(item,i) in businessOption" :key="i"
                     :label="item.label.length>20?(item.label.slice(0,19)+'...'):item.label"
                     :value="item.value"></el-option>
        </el-select>
      </div>
      <div>
        <el-select style="width:100%;" v-model="searchForm.brand_id" clearable filterable
                   :popper-append-to-body="false"
                   class="input-width" placeholder="品牌">
          <el-option v-for="(item,i) in brandOption" :key="i"
                     :label="item.label.length>20?(item.label.slice(0,19)+'...'):item.label"
                     :value="item.value"></el-option>
        </el-select>
      </div>
      <div style="margin-left: 20px">
        <el-select style="width:100%;" v-model="searchForm.sort_type" clearable filterable
                   :popper-append-to-body="false"
                   @change="changeSearchType"
                   class="input-width" placeholder="排序方式">
          <el-option v-for="(item,i) in sortOption" :key="i"
                     :label="item.label"
                     :value="item.value"></el-option>
        </el-select>
      </div>
      <div style="margin-left: 20px">
        <el-select style="width:100%;" v-model="searchForm.show_type" clearable filterable
                   :popper-append-to-body="false"
                   class="input-width" placeholder="显示方式">
          <el-option v-for="(item,i) in [{label:'普通模式',value:'1'},{label:'同货号汇总',value:'2'}]"
                     :key="i"
                     :label="item.label"
                     :value="item.value"></el-option>
        </el-select>
      </div>
    </div>
    <div class="search-bar seprator">

      <div style="display:flex;align-items:center;">
        <span>
            <!--{{totalCount}}个待买&nbsp;&nbsp;-->
        </span>
        <!--<el-button style="width:70px;" v-show="mailList.filter(i=>i.isSelected).length" :loading="multipleUpdating" class="block btn-14" type="info" @click="updateMultipleMail()">批量更新</el-button>-->
      </div>
      <div>
        <div style="display:inline-block;">
          <el-date-picker format="yyyy-MM-dd HH:mm" v-model="timeRange" type="datetimerange" range-separator="至"
                          start-placeholder="开始时间"
                          end-placeholder="结束时间" :default-time="['00:00:00', '23:59:59']" @change="search">
          </el-date-picker>
        </div>
        <div style="display:inline-block;">
          <el-input class="commbo-input" style="width:500px;" clearable
                    v-model="searchWord">
            <el-select class="search-preix" v-model="keyword_type" slot="prepend" placeholder="请选择"
            >
              <!--<el-option label="全文搜索" value="0"></el-option>-->
              <el-option label="货号" value="1"></el-option>
              <el-option label="用户名" value="2"></el-option>
            </el-select>
            <span style="cursor:pointer" @click="search()" slot="append">&nbsp;&nbsp;搜索&nbsp;&nbsp;</span>
          </el-input>
        </div>
        <div v-if="searchForm.business_id && keyword_type=='2' && searchWord" style="display:inline-block;">
          <el-button style="margin-left:10px;width:130px" type="primary" @click="openAddCartDialog" >添加待买清单</el-button>
        </div>
      </div>
    </div>
    <div class="table">
      <CartBody v-on:search="search" :list="dataList" :type="searchForm.show_type"></CartBody>
    </div>
    <div class="yd-pagination" v-if="totalCount / searchForm.limit > 1">
      <el-pagination :page-size="searchForm.limit" :pager-count="5" :current-page.sync="searchForm.page"
                     layout="prev, pager, next"
                     next-text="下一页" prev-text="上一页" :total="totalCount" @current-change="search">
      </el-pagination>
    </div>
    <el-dialog v-if="addCartVisible" class="el-dialog-lg" :close-on-click-modal="false" :modal="true" :visible.sync="addCartVisible" width="100%" :fullscreen="true">
      <AddUserCart :username="user_name" :merchant="merchant" @canceladdcart="closeAddCart" @confirmAddCart="confirmAddCart"></AddUserCart>
    </el-dialog>
  </div>
</template>

<script>
  import api from '../../../services/api.js'
  import {copy} from '../../../services/tools.js'
  import CartBody from './CartBody'
  import AddUserCart from './AddCart'

  let _ = require('lodash')

  export default {
    name: 'cartList',
    components: {
      CartBody: CartBody,
      AddUserCart:AddUserCart
    },
    data() {
      return {
        addCartVisible:false,
        activeName: '',
        totalCount: 0,
        dataList: [],
        searchWord: '',
        keyword_type: '1',
        timeRange: [],
        selectAll: false,
        businessOption: [],
        brandOption: [],
        sortOption: [{label: '创建时间', value: '1'}, {label: '添加用户数', value: '2'}],
        searchForm: {
          page: 1,
          limit: 10,
          business_id: '',
          sort_type: '2',
          show_type: '2',
        },
        columns: [
          {name: '添加时间', field: 'create_time', width: '200px'},
          {name: '价格', field: 'price', width: '200px'},
        ],
        user_id:'',
        user_name:'',
        merchant:{}
      }
    },
    async mounted() {
      this.timeRange = [new Date(new Date().getTime() - 30 * 24 * 3600 * 1000), new Date()]
      await this.search()

    },
    methods: {
      closeAddCart(){
        this.addCartVisible=false;
      },
      async confirmAddCart(data){
        let res = await api.post(this, {
          path: 'cart.php',
          api: 'add_to_user_list',
          data: {
            account_id_list:[this.user_id],
            product_list:data
          }
        })
        res = res.body
        if (res.status == 'ok') {
          this.$message.success('添加成功');
          this.addCartVisible=false;
        }else{
          this.$message.error('添加失败')
        }
        
        this.addCartVisible=true
      },
      confirmMerchant(value){
        this.merchant = this.businessOption.find((i)=>i.value==value)
        console.log('select',this.merchant);

      },
      async openAddCartDialog(){
        let { body } = await api.getBuyerList(this, {
          keyword: this.searchWord
        })
        let res = body.result || []
        if (res.length == 0) {
          this.$message.error('请输入一个正确的用户名')
        }
        else{
          this.user_id = res[0].account_id;
          this.user_name = res[0].username;
          this.addCartVisible=true;
        }
      },
      _copy(val) {
        copy(val);
      },
      changeSearchType(val) {
        this.search();
      },
      handleSpec(spec) {
        let html = "";
        if (!spec) {
          return html;
        }
        let keys = Object.keys(spec);
        keys.map(item => {
          if (spec[item]) {
            html += `<p>${item}:${spec[item]}</p>`
          }
        })
        return html;
      },
      changeCollapse() {
      },
      toggleSelect() {
        this.dataList.forEach((m) => {
          m.isSelected = this.selectAll
        })
      },
      search(obj) {
        if (obj&& obj.username) {
          this.searchWord = obj.username;
          this.keyword_type = '2'
        }
        const generateParams = () => {
          let params = {};
          if (this.timeRange && this.timeRange.length) {
            params.start_time = this.$moment(this.timeRange[0]).format('YYYY-MM-DD HH:mm')
            params.end_time = this.$moment(this.timeRange[1]).format('YYYY-MM-DD HH:mm')
          }
          params.limit = this.searchForm.limit;
          params.page = this.searchForm.page;

          for (let p in this.searchForm) {
            if (this.searchForm[p])
              params[p] = this.searchForm[p]
          }

          if (this.searchWord) {
            switch (this.keyword_type) {
              case '1':
                params.sku = this.searchWord;
                break;
              case '2':
                params.user_name = this.searchWord;
                break;
              case '3':
                params.merchant_order_number = this.searchWord;
                break;
            }
          }
          return params
        }
        let params = generateParams();
        api.getUnderBuyBusinessList(this, params).then(res => {
            this.businessOption = res.body.result.map(item => {
              return {
                value: item.business_id, 
                website: item.website,
                label: item.business_name,
                currency:item.currency,
                currency_symbol:item.currency_symbol,
                country:item.country,
                buyer_fixed_amount:item.buyer_fixed_amount,
                buyer_service_rate:item.buyer_service_rate,
                single_fixed_amount:item.single_fixed_amount,
                single_service_rate:item.single_service_rate
              }
            });
        });
        api.getUnderBuyBrandList(this, params).then(res => {
          this.brandOption = res.body.result.map(item => {
            return {value: item.brand_id, label: item.brand_name}
          });
        });
        this.getList(params)
      },
      getList(params) {
        this.dataList = null;
        this.totalCount = null;
        api.getUnderBuyList(this, params).then((res) => {
          this.dataList = res.body.rows
            .map(item => {
            if (item.enable_alternate_images == 1) {
              item.picture = '';
              if (item.alternate_image_json && item.alternate_image_json.length) {
                let find = item.alternate_image_json.find(i => i.show == '1');
                if (find) {
                  item.picture = find.url;
                }
              }
            }
            return item;
          });
          this.totalCount = +res.body.total;
        })
      },
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  .empty-content {
    padding: 50px 0 50px;
  }

  .search-preix {
    min-width: 7rem;
  }
</style>

<style lang="scss">
  .order-list {
    margin-bottom: 80px;

    .el-tabs__content {
      overflow: visible;
    }
  }

  .search-bar {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    margin-bottom: 10px;
    justify-content: space-between;

    &.seprator {
      justify-content: space-between;
    }
  }

  .table {
    margin-top: 43px;
    overflow-x: auto;
    overflow-y: hidden;

    .table-head,
    .table-body {
      display: flex;
    }

    .table-head {
      padding: 18px 11px 18px 21px;
      border-left: 2px solid transparent;
      border-right: 2px solid transparent;
    }

    .table-row-title {
      display: flex;
    }

    .table-head {
      color: #888888;
    }

    .seporater-order {
      padding: 0 50px;
      height: 40px;
      border: 1px solid #D7D7D7;
      border-top: none;
      line-height: 40px;
    }

    .table-row-content {
      //display:flex;
      padding: 25px 50px 30px;
      border: 1px solid #D7D7D7;
      border-top: none;

      &.order {
        display: block;
        border-top: 1px solid #D7D7D7;
      }
    }

    .table-row-seperator {
      float: left;
      height: 33px;
      width: 100%;
      border-left: 1pX dashed #D7D7D7;
      border-right: 1px dashed #D7D7D7;
    }
  }

  .yd-pagination {
    margin-top: 30px;
  }

  .redirct {
    font-size: 24px;
    line-height: 33px;
    margin-top: 54px;
    padding-bottom: 70px;

    .completion {
      background-image: url('../../../assets/images/Group@2x.png');
      background-position: 0 0;
      background-size: contain;
    }

    a {
      font-size: 16px;
    }

    p {
      line-height: 24px;
      color: #888
    }
  }

  .product-price label.danger {
    font-size: 18px;
    color: #FF4650;
  }

  .product-item {
    display: flex;
    height: 120px;
    margin-bottom: 30px;

    &:first-child {
      padding-top: 0;
    }

    &:last-child {
      border-bottom: 0;
      padding-bottom: 0;
      margin-bottom: 0;
    }

    .product-detail {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      flex: 1;
      position: relative;
      top: -3px;
      margin-left: 20px;

      .product-name {
        font-size: 14px;
        color: #333333;
      }

      .product-price {
        line-height: 32px;
        color: black;

        label {
          font-size: 18px;
        }
      }

      .product-price del {
        font-size: 16px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/orders/cart/list.vue